import gql from "graphql-tag";

export const LOST_PASSWORD = gql`
  mutation LostPassword($email: String!) {
    lostPassword(email: $email)
  }
`;
